import React from "react";
import { FALLBACK_IMG } from "@/data/content";

// Image with graceful fallback + editorial hover treatment
export const Img = ({ src, alt, className = "", imgClassName = "", parallax = false, natural = false }) => {
  const handleError = (e) => {
    if (e.target.src !== FALLBACK_IMG) e.target.src = FALLBACK_IMG;
  };
  if (natural) {
    // Render at the image's intrinsic aspect ratio — no cropping.
    return (
      <div className={`overflow-hidden bg-stone2 ${className}`}>
        <img
          src={src}
          alt={alt}
          onError={handleError}
          loading="lazy"
          className={`block w-full h-auto transition-transform duration-700 ease-out will-change-transform ${imgClassName}`}
        />
      </div>
    );
  }
  return (
    <div className={`overflow-hidden bg-stone2 ${className}`}>
      <img
        src={src}
        alt={alt}
        onError={handleError}
        loading="lazy"
        className={`h-full w-full object-cover transition-transform duration-700 ease-out will-change-transform ${imgClassName}`}
      />
    </div>
  );
};

export default Img;
